var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/pubsub-js/src/pubsub.js
var require_pubsub = __commonJS({
  "node_modules/pubsub-js/src/pubsub.js"(exports, module) {
    (function(root, factory) {
      "use strict";
      var PubSub2 = {};
      if (root.PubSub) {
        PubSub2 = root.PubSub;
        console.warn("PubSub already loaded, using existing version");
      } else {
        root.PubSub = PubSub2;
        factory(PubSub2);
      }
      if (typeof exports === "object") {
        if (module !== void 0 && module.exports) {
          exports = module.exports = PubSub2;
        }
        exports.PubSub = PubSub2;
        module.exports = exports = PubSub2;
      } else if (typeof define === "function" && define.amd) {
        define(function() {
          return PubSub2;
        });
      }
    })(typeof window === "object" && window || exports || global, function(PubSub2) {
      "use strict";
      var messages = {}, lastUid = -1, ALL_SUBSCRIBING_MSG = "*";
      function hasKeys(obj) {
        var key;
        for (key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return true;
          }
        }
        return false;
      }
      function throwException(ex) {
        return function reThrowException() {
          throw ex;
        };
      }
      function callSubscriberWithDelayedExceptions(subscriber, message, data) {
        try {
          subscriber(message, data);
        } catch (ex) {
          setTimeout(throwException(ex), 0);
        }
      }
      function callSubscriberWithImmediateExceptions(subscriber, message, data) {
        subscriber(message, data);
      }
      function deliverMessage(originalMessage, matchedMessage, data, immediateExceptions) {
        var subscribers = messages[matchedMessage], callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions, s;
        if (!Object.prototype.hasOwnProperty.call(messages, matchedMessage)) {
          return;
        }
        for (s in subscribers) {
          if (Object.prototype.hasOwnProperty.call(subscribers, s)) {
            callSubscriber(subscribers[s], originalMessage, data);
          }
        }
      }
      function createDeliveryFunction(message, data, immediateExceptions) {
        return function deliverNamespaced() {
          var topic = String(message), position = topic.lastIndexOf(".");
          deliverMessage(message, message, data, immediateExceptions);
          while (position !== -1) {
            topic = topic.substr(0, position);
            position = topic.lastIndexOf(".");
            deliverMessage(message, topic, data, immediateExceptions);
          }
          deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
        };
      }
      function hasDirectSubscribersFor(message) {
        var topic = String(message), found = Boolean(Object.prototype.hasOwnProperty.call(messages, topic) && hasKeys(messages[topic]));
        return found;
      }
      function messageHasSubscribers(message) {
        var topic = String(message), found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG), position = topic.lastIndexOf(".");
        while (!found && position !== -1) {
          topic = topic.substr(0, position);
          position = topic.lastIndexOf(".");
          found = hasDirectSubscribersFor(topic);
        }
        return found;
      }
      function publish(message, data, sync, immediateExceptions) {
        message = typeof message === "symbol" ? message.toString() : message;
        var deliver = createDeliveryFunction(message, data, immediateExceptions), hasSubscribers = messageHasSubscribers(message);
        if (!hasSubscribers) {
          return false;
        }
        if (sync === true) {
          deliver();
        } else {
          setTimeout(deliver, 0);
        }
        return true;
      }
      PubSub2.publish = function(message, data) {
        return publish(message, data, false, PubSub2.immediateExceptions);
      };
      PubSub2.publishSync = function(message, data) {
        return publish(message, data, true, PubSub2.immediateExceptions);
      };
      PubSub2.subscribe = function(message, func) {
        if (typeof func !== "function") {
          return false;
        }
        message = typeof message === "symbol" ? message.toString() : message;
        if (!Object.prototype.hasOwnProperty.call(messages, message)) {
          messages[message] = {};
        }
        var token = "uid_" + String(++lastUid);
        messages[message][token] = func;
        return token;
      };
      PubSub2.subscribeAll = function(func) {
        return PubSub2.subscribe(ALL_SUBSCRIBING_MSG, func);
      };
      PubSub2.subscribeOnce = function(message, func) {
        var token = PubSub2.subscribe(message, function() {
          PubSub2.unsubscribe(token);
          func.apply(this, arguments);
        });
        return PubSub2;
      };
      PubSub2.clearAllSubscriptions = function clearAllSubscriptions() {
        messages = {};
      };
      PubSub2.clearSubscriptions = function clearSubscriptions(topic) {
        var m;
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
            delete messages[m];
          }
        }
      };
      PubSub2.countSubscriptions = function countSubscriptions(topic) {
        var m;
        var token;
        var count = 0;
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
            for (token in messages[m]) {
              count++;
            }
            break;
          }
        }
        return count;
      };
      PubSub2.getSubscriptions = function getSubscriptions(topic) {
        var m;
        var list = [];
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
            list.push(m);
          }
        }
        return list;
      };
      PubSub2.unsubscribe = function(value) {
        var descendantTopicExists = function(topic) {
          var m2;
          for (m2 in messages) {
            if (Object.prototype.hasOwnProperty.call(messages, m2) && m2.indexOf(topic) === 0) {
              return true;
            }
          }
          return false;
        }, isTopic = typeof value === "string" && (Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value)), isToken = !isTopic && typeof value === "string", isFunction = typeof value === "function", result = false, m, message, t;
        if (isTopic) {
          PubSub2.clearSubscriptions(value);
          return;
        }
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m)) {
            message = messages[m];
            if (isToken && message[value]) {
              delete message[value];
              result = value;
              break;
            }
            if (isFunction) {
              for (t in message) {
                if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value) {
                  delete message[t];
                  result = true;
                }
              }
            }
          }
        }
        return result;
      };
    });
  }
});

// src/utils/constants.js
var PUB_SUB_EVENTS = {
  colorChange: "color-change",
  sizeChange: "size-change",
  variantChange: "variant-change",
  blindsChange: "blinds-change",
  initialize: "initialize",
  onlyUpdateUrl: "only-update-url",
  blindsUpdatePrice: "blinds-update-price",
  updateControls: "update-controls",
  upsellChange: "upsell-change"
};

// src/utils/normalize-property.js
var stripAndLower = (value) => String(value != null ? value : "").toLowerCase().replace(/\s+/g, "");
var SLAT_WIDTH = {
  "25mm": "25mm",
  "50mm": "50mm",
  "65mm": "65mm"
};
var LADDER_CORD = "ladderkoord";
var LADDER_BAND = "ladderband";
var LADDER_TAPING = {
  ladderkoord: LADDER_CORD,
  laddercord: LADDER_CORD,
  cord: LADDER_CORD,
  leiterschnur: LADDER_CORD,
  ladderband: LADDER_BAND,
  ladderstrap: LADDER_BAND,
  laddertape: LADDER_BAND,
  strap: LADDER_BAND,
  ladderkleber: LADDER_BAND,
  leiterband: LADDER_BAND
};
var LADDER_TAPING_STEMS = [
  [/koord|kord|cord|schnur|corde|cuerda/, LADDER_CORD],
  [/band|tape|strap|kleber|ruban|cinta|nastro/, LADDER_BAND]
];
var foldLabel = (value) => String(value != null ? value : "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, "");
var translatedLadderLabels = () => {
  const product = typeof window !== "undefined" ? window.product : null;
  return {
    [foldLabel(product == null ? void 0 : product.ladderkoord)]: LADDER_CORD,
    [foldLabel(product == null ? void 0 : product.ladderband)]: LADDER_BAND
  };
};
var resolveLadderTaping = (value) => {
  const key = foldLabel(value);
  if (!key)
    return null;
  if (LADDER_TAPING[key])
    return LADDER_TAPING[key];
  const translated = translatedLadderLabels()[key];
  if (translated)
    return translated;
  const stem = LADDER_TAPING_STEMS.find(([pattern]) => pattern.test(key));
  return stem ? stem[1] : null;
};
var LADDER_TAPING_VARIANT_TOKENS = {
  [LADDER_CORD]: "ladderCord",
  [LADDER_BAND]: "ladderStrap"
};
var ladderTapingVariantToken = (value) => {
  const canonical = resolveLadderTaping(value);
  return canonical ? LADDER_TAPING_VARIANT_TOKENS[canonical] : null;
};
var ladderTapingVariantTokenFromElement = (element) => {
  var _a, _b;
  if (!element)
    return null;
  const candidates = [
    (_a = element.getAttribute) == null ? void 0 : _a.call(element, "data-canonical-value"),
    (_b = element.getAttribute) == null ? void 0 : _b.call(element, "data-variant-option-value"),
    element.value
  ];
  for (const candidate of candidates) {
    const token = ladderTapingVariantToken(candidate);
    if (token)
      return token;
  }
  return null;
};
var COLOR_STYLE_PREMIUM = "premium";
var COLOR_STYLE_BASIC = "basic";
var COLOR_STYLE = {
  premium: COLOR_STYLE_PREMIUM,
  pramie: COLOR_STYLE_PREMIUM,
  praemie: COLOR_STYLE_PREMIUM,
  premie: COLOR_STYLE_PREMIUM,
  basic: COLOR_STYLE_BASIC,
  basis: COLOR_STYLE_BASIC,
  standaard: COLOR_STYLE_BASIC
};
var resolveColorStyle = (value) => {
  const key = foldLabel(value);
  if (!key)
    return null;
  if (COLOR_STYLE[key])
    return COLOR_STYLE[key];
  const product = typeof window !== "undefined" ? window.product : null;
  if (key === foldLabel(product == null ? void 0 : product.premium))
    return COLOR_STYLE_PREMIUM;
  if (key === foldLabel(product == null ? void 0 : product.basic))
    return COLOR_STYLE_BASIC;
  return null;
};
var resolveSlatWidth = (value) => {
  const match = foldLabel(value).match(/^(\d{2,3})mm$/);
  return match ? `${match[1]}mm` : null;
};
var OPTION_VALUE_RESOLVERS = [resolveLadderTaping, resolveColorStyle, resolveSlatWidth];
var optionValuesMatch = (selectedValue, variantValue) => {
  const selected = foldLabel(selectedValue);
  const variant = foldLabel(variantValue);
  if (!selected || !variant)
    return false;
  if (selected === variant)
    return true;
  return OPTION_VALUE_RESOLVERS.some((resolve) => {
    const resolvedSelected = resolve(selectedValue);
    const resolvedVariant = resolve(variantValue);
    return Boolean(resolvedSelected) && resolvedSelected === resolvedVariant;
  });
};
var COLOR_KEYWORD = {
  matchend: "matchend",
  matching: "matchend",
  passend: "matchend",
  black: "black",
  zwart: "black",
  schwarz: "black",
  white: "white",
  wit: "white",
  weiss: "white",
  wei\u00DF: "white"
};
var CONTROLS = {
  shared: "shared",
  gedeeld: "shared",
  geteilt: "shared",
  left: "left",
  links: "left",
  right: "right",
  rechts: "right"
};
var FRAME_SPACING = {
  betweenframe: "betweenFrame",
  tussendedag: "betweenFrame",
  indedag: "betweenFrame",
  inderlaibung: "betweenFrame",
  zwischendemrahmen: "betweenFrame",
  insidemount: "betweenFrame",
  onframe: "onFrame",
  opdedag: "onFrame",
  aufderlaibung: "onFrame",
  aufdemrahmen: "onFrame",
  outsidemount: "onFrame"
};
var lookup = (map, value) => {
  var _a;
  if (value == null || value === "")
    return value;
  return (_a = map[stripAndLower(value)]) != null ? _a : value;
};
var normalizeSlatWidth = (value) => lookup(SLAT_WIDTH, value);
var normalizeLadderTaping = (value) => {
  var _a;
  if (value == null || value === "")
    return value;
  return (_a = resolveLadderTaping(value)) != null ? _a : value;
};
var normalizeColorKeyword = (value) => lookup(COLOR_KEYWORD, value);
var normalizeControls = (value) => lookup(CONTROLS, value);
var normalizeFrameSpacing = (value) => lookup(FRAME_SPACING, value);
var OPTION_VALUE_NORMALIZERS = {
  slatWidth: normalizeSlatWidth,
  ladderTaping: normalizeLadderTaping,
  ladderTapingColor: normalizeColorKeyword,
  topBottomRailColor: normalizeColorKeyword,
  controls: normalizeControls,
  frameSpacing: normalizeFrameSpacing,
  colorStyle: (value) => {
    var _a;
    return (_a = resolveColorStyle(value)) != null ? _a : value;
  }
};
var canonicalOptionValue = (optionName, value) => {
  const normalize = OPTION_VALUE_NORMALIZERS[optionName];
  return normalize ? normalize(value) : value;
};
var URL_PARAM_OPTIONS = {
  sw: "slatWidth",
  f: "frameSpacing",
  lt: "ladderTaping",
  "lt-col": "ladderTapingColor",
  con: "controls",
  tbr: "topBottomRailColor"
};
var CANONICAL_URL_VALUES = {
  ladderTaping: [LADDER_CORD, LADDER_BAND],
  frameSpacing: ["betweenFrame", "onFrame"],
  controls: ["shared", "left", "right"],
  ladderTapingColor: ["matchend", "black", "white"],
  topBottomRailColor: ["matchend", "black", "white"]
};
var URL_VALUE_SAFETY_NET = {
  ladderTaping: {
    ladderkoord: LADDER_CORD,
    laddercord: LADDER_CORD,
    leiterschnur: LADDER_CORD,
    koord: LADDER_CORD,
    schnur: LADDER_CORD,
    cord: LADDER_CORD,
    ladderband: LADDER_BAND,
    ladderstrap: LADDER_BAND,
    laddertape: LADDER_BAND,
    leiterband: LADDER_BAND,
    band: LADDER_BAND,
    tape: LADDER_BAND,
    strap: LADDER_BAND
  },
  frameSpacing: {
    indedag: "betweenFrame",
    tussendedag: "betweenFrame",
    zwischendemrahmen: "betweenFrame",
    zwischenrahmen: "betweenFrame",
    betweenframe: "betweenFrame",
    inframe: "betweenFrame",
    opdedag: "onFrame",
    aufdemrahmen: "onFrame",
    aufrahmen: "onFrame",
    onframe: "onFrame"
  },
  controls: {
    gedeeld: "shared",
    geteilt: "shared",
    shared: "shared",
    links: "left",
    left: "left",
    rechts: "right",
    right: "right"
  },
  ladderTapingColor: {
    matchend: "matchend",
    matching: "matchend",
    passend: "matchend",
    zwart: "black",
    schwarz: "black",
    black: "black",
    wit: "white",
    weiss: "white",
    white: "white"
  }
};
URL_VALUE_SAFETY_NET.topBottomRailColor = URL_VALUE_SAFETY_NET.ladderTapingColor;
var canonicalUrlValue = (param, value) => {
  var _a, _b;
  const optionName = URL_PARAM_OPTIONS[param];
  if (!optionName || value == null || value === "")
    return value;
  const resolved = canonicalOptionValue(optionName, value);
  const allowed = CANONICAL_URL_VALUES[optionName];
  if (!allowed || allowed.includes(resolved))
    return resolved;
  return (_b = (_a = URL_VALUE_SAFETY_NET[optionName]) == null ? void 0 : _a[foldLabel(value)]) != null ? _b : resolved;
};
var canonicalizeUrlOptionValues = (url) => {
  let changed = false;
  Object.keys(URL_PARAM_OPTIONS).forEach((param) => {
    const value = url.searchParams.get(param);
    if (value == null || value === "")
      return;
    const canonical = canonicalUrlValue(param, value);
    if (canonical != null && canonical !== value) {
      url.searchParams.set(param, canonical);
      changed = true;
    }
  });
  return changed;
};
var findOptionInput = (fieldsetName, value, root = typeof document !== "undefined" ? document : null) => {
  var _a;
  const fieldset = (_a = root == null ? void 0 : root.querySelector) == null ? void 0 : _a.call(root, `fieldset[name="${fieldsetName}"]`);
  if (!fieldset)
    return null;
  const inputs = Array.from(fieldset.querySelectorAll("input"));
  return inputs.find((input) => input.value === value) || inputs.find((input) => optionValuesMatch(input.getAttribute("data-canonical-value") || input.value, value)) || null;
};

// src/utils/blinds-config.js
var CONFIG_VERSION = 1;
var ROLE_COLOR = "color";
var ROLE_SIZE = "size";
var ROLE_RAIL = "rail";
var ROLE_ADDON = "addon";
var text = (formData, key) => {
  const value = formData.get(key);
  if (value == null)
    return null;
  const trimmed = String(value).trim();
  return trimmed.length > 0 && trimmed !== "undefined" && trimmed !== "null" ? trimmed : null;
};
var number = (formData, key) => {
  const value = text(formData, key);
  if (value == null)
    return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};
var compact = (object) => {
  const result = {};
  Object.entries(object).forEach(([key, value]) => {
    if (value !== null && value !== void 0 && value !== "")
      result[key] = value;
  });
  return result;
};
var resolveMaterial = (formData) => {
  const explicit = text(formData, "_material");
  if (explicit === "wood" || explicit === "aluminium")
    return explicit;
  const url = `${text(formData, "_color_handle") || ""} ${text(formData, "_reconfigure_url") || ""}`.toLowerCase();
  if (url.includes("wood") || url.includes("hout"))
    return "wood";
  return explicit || null;
};
var selectedAddons = (formData) => {
  const raw = text(formData, "_upSellIds");
  if (!raw)
    return [];
  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch (error) {
    console.error("blinds-config: could not parse _upSellIds", error);
    return [];
  }
  if (!Array.isArray(parsed))
    return [];
  const baseboardVariantId = text(formData, "_baseboard_variant_id");
  return parsed.filter((addon) => addon && addon.id).map((addon) => {
    const entry = compact({
      variantId: String(addon.id),
      title: addon.title ? String(addon.title) : null
    });
    if (baseboardVariantId && String(addon.id) === baseboardVariantId) {
      const baseboard = compact({
        leftHeight: number(formData, "baseboard_left_height"),
        leftDepth: number(formData, "baseboard_left_depth"),
        rightHeight: number(formData, "baseboard_right_height"),
        rightDepth: number(formData, "baseboard_right_depth")
      });
      if (Object.keys(baseboard).length > 0)
        entry.baseboard = baseboard;
    }
    return entry;
  });
};
var buildBlindsConfig = (formData, { parentId } = {}) => {
  const railColor = normalizeColorKeyword(text(formData, "topBottomRailColor"));
  const config = {
    v: CONFIG_VERSION,
    type: "blinds",
    parentId: parentId || null,
    material: resolveMaterial(formData),
    color: compact({ productId: text(formData, "_color_product_id") }),
    size: compact({
      width: number(formData, "width"),
      height: number(formData, "height")
    }),
    slatWidth: normalizeSlatWidth(text(formData, "slatWidth")),
    ladderTaping: normalizeLadderTaping(text(formData, "ladderTaping")),
    ladderTapingColor: normalizeColorKeyword(text(formData, "ladderTapingColor")),
    controls: normalizeControls(text(formData, "controls")),
    frameSpacing: normalizeFrameSpacing(text(formData, "frameSpacing")),
    note: text(formData, "note")
  };
  if (railColor)
    config.topBottomRail = { color: railColor };
  const addons = selectedAddons(formData).filter((addon) => addon.baseboard).map((addon) => ({ variantId: addon.variantId, baseboard: addon.baseboard }));
  if (addons.length > 0)
    config.addons = addons;
  return compact(config);
};

// src/utils/cart-labels.js
var ENGLISH_KEYS = {
  material: "Material",
  color: "Color",
  width: "Width",
  height: "Height",
  slatWidth: "Slat width",
  ladder: "Ladder type",
  ladderTapingColor: "Ladder color",
  controls: "Controls",
  frameSpacing: "Placement",
  topBottomRail: "Top and bottom rail",
  note: "Room or note",
  baseboardLeftHeight: "Baseboard left height",
  baseboardLeftDepth: "Baseboard left depth",
  baseboardRightHeight: "Baseboard right height",
  baseboardRightDepth: "Baseboard right depth"
};
var ENGLISH_VALUES = {
  material: { aluminium: "Aluminium", wood: "Wood" },
  ladderTaping: { ladderkoord: "Ladder cord", ladderband: "Ladder strap" },
  colorKeyword: { matchend: "Matching", black: "Black", white: "White" },
  controls: { shared: "Shared", left: "Left", right: "Right" },
  frameSpacing: { betweenFrame: "Between frame", onFrame: "On frame" }
};
var globalCart = () => (typeof window !== "undefined" ? window.cart : null) || {};
var capitalize = (value) => {
  if (value == null)
    return null;
  const text2 = String(value).trim();
  if (text2.length === 0)
    return null;
  return text2.charAt(0).toUpperCase() + text2.slice(1);
};
var propertyKey = (key) => {
  const translated = capitalize(globalCart()[key]);
  return translated || capitalize(ENGLISH_KEYS[key]) || key;
};
var propertyValue = (group, value) => {
  var _a, _b, _c;
  if (value == null || value === "")
    return null;
  const translated = capitalize((_b = (_a = globalCart().labels) == null ? void 0 : _a[group]) == null ? void 0 : _b[value]);
  if (translated)
    return translated;
  return capitalize((_c = ENGLISH_VALUES[group]) == null ? void 0 : _c[value]) || capitalize(value);
};
var selectedLabels = (root = typeof document !== "undefined" ? document : null) => {
  const labels = {};
  if (!(root == null ? void 0 : root.querySelectorAll))
    return labels;
  root.querySelectorAll("fieldset input:checked, fieldset select option[selected]").forEach((element) => {
    var _a;
    const name = (_a = element.getAttribute) == null ? void 0 : _a.call(element, "name");
    if (!name)
      return;
    const label = element.getAttribute("data-translated-value") || element.getAttribute("data-product-title") || element.value;
    if (label)
      labels[name] = String(label);
  });
  return labels;
};
var optionLabel = (labels, inputName, group, canonicalValue) => {
  const fromDom = capitalize(labels == null ? void 0 : labels[inputName]);
  if (fromDom)
    return fromDom;
  return group ? propertyValue(group, canonicalValue) : capitalize(canonicalValue);
};
var millimetres = (value) => {
  if (value == null || value === "")
    return null;
  const number2 = Number(value);
  return Number.isFinite(number2) ? `${number2} mm` : String(value);
};

// src/utils/dissect-form.js
var generateParentId = () => Date.now().toString(36) + Math.random().toString(36).substring(2);
var withColorLine = () => {
  var _a;
  return Boolean(typeof window !== "undefined" && ((_a = window.cart) == null ? void 0 : _a.bundleParent));
};
var withValue = (properties, key, value) => {
  if (value == null || value === "")
    return properties;
  properties[key] = value;
  return properties;
};
var translatedProperties = (config, labels, colorTitle) => {
  var _a, _b, _c;
  const properties = {};
  withValue(properties, propertyKey("material"), propertyValue("material", config.material));
  withValue(properties, propertyKey("color"), capitalize(labels.color || colorTitle));
  withValue(properties, propertyKey("width"), millimetres((_a = config.size) == null ? void 0 : _a.width));
  withValue(properties, propertyKey("height"), millimetres((_b = config.size) == null ? void 0 : _b.height));
  withValue(properties, propertyKey("slatWidth"), optionLabel(labels, "slatWidth", null, config.slatWidth));
  withValue(properties, propertyKey("ladder"), optionLabel(labels, "ladderTaping", "ladderTaping", config.ladderTaping));
  withValue(
    properties,
    propertyKey("ladderTapingColor"),
    optionLabel(labels, "ladderTapingColor", "colorKeyword", config.ladderTapingColor)
  );
  withValue(properties, propertyKey("controls"), optionLabel(labels, "controls", "controls", config.controls));
  withValue(
    properties,
    propertyKey("frameSpacing"),
    optionLabel(labels, "frameSpacing", "frameSpacing", config.frameSpacing)
  );
  withValue(
    properties,
    propertyKey("topBottomRail"),
    optionLabel(labels, "topBottomRailColor", "colorKeyword", (_c = config.topBottomRail) == null ? void 0 : _c.color)
  );
  withValue(properties, propertyKey("note"), capitalize(config.note));
  return properties;
};
var sizeProperties = (config, { width = true } = {}) => {
  var _a, _b;
  const properties = {};
  if (width)
    withValue(properties, propertyKey("width"), millimetres((_a = config.size) == null ? void 0 : _a.width));
  withValue(properties, propertyKey("height"), millimetres((_b = config.size) == null ? void 0 : _b.height));
  return properties;
};
var baseboardProperties = (baseboard) => {
  const properties = {};
  if (!baseboard)
    return properties;
  withValue(properties, propertyKey("baseboardLeftHeight"), millimetres(baseboard.leftHeight));
  withValue(properties, propertyKey("baseboardLeftDepth"), millimetres(baseboard.leftDepth));
  withValue(properties, propertyKey("baseboardRightHeight"), millimetres(baseboard.rightHeight));
  withValue(properties, propertyKey("baseboardRightDepth"), millimetres(baseboard.rightDepth));
  return properties;
};
var dissectForm = (formData) => {
  var _a, _b, _c;
  const defaultQuantity = 1;
  const parentId = generateParentId();
  const labels = selectedLabels();
  const value = (key) => formData.get(key) ? formData.get(key) : null;
  const quantity = value("quantity") || defaultQuantity;
  const colorVariantId = value("id");
  const sizeVariantId = value("size-variant-id");
  const railVariantId = value("_topBottomRailId");
  const colorTitle = value("color");
  const colorHandle = value("_color_handle");
  const reconfigureUrl = typeof window !== "undefined" ? String(new URL(window.location)) : null;
  const config = buildBlindsConfig(formData, { parentId });
  const cart = typeof document !== "undefined" ? document.querySelector("cart-notification") || document.querySelector("cart-drawer") : null;
  const visibleProperties = translatedProperties(config, labels, colorTitle);
  const items = [];
  const colorItem = colorVariantId ? {
    id: colorVariantId,
    quantity,
    "product-id": ((_a = config.color) == null ? void 0 : _a.productId) || null,
    properties: { _parentId: parentId, _role: ROLE_COLOR }
  } : null;
  const sizeItem = sizeVariantId ? {
    id: sizeVariantId,
    quantity,
    "product-id": value("size-product-id"),
    properties: { _parentId: parentId, _role: ROLE_SIZE, ...sizeProperties(config) }
  } : null;
  if (withColorLine() && colorItem) {
    items.push(colorItem);
    if (sizeItem)
      items.push(sizeItem);
  } else if (sizeItem) {
    items.push(sizeItem);
  } else if (colorItem) {
    items.push(colorItem);
  }
  const parentProperties = (_b = items[0]) == null ? void 0 : _b.properties;
  if (parentProperties) {
    parentProperties._type = "blinds";
    parentProperties._config = JSON.stringify(config);
    parentProperties._display = JSON.stringify(Object.entries(visibleProperties));
    withValue(parentProperties, "_slatWidth", config.slatWidth);
    withValue(parentProperties, "_reconfigureUrl", reconfigureUrl);
    withValue(parentProperties, "_colorTitle", colorTitle);
    withValue(parentProperties, "_colorHandle", colorHandle);
    Object.assign(parentProperties, visibleProperties);
  }
  if (railVariantId) {
    items.push({
      id: railVariantId,
      quantity: defaultQuantity,
      properties: {
        _parentId: parentId,
        _role: ROLE_RAIL,
        // Kept so carts and orders created before the bundle rollout keep rendering.
        _isTopBottomRail: true,
        ...withValue(
          sizeProperties(config, { width: false }),
          propertyKey("color"),
          optionLabel(labels, "topBottomRailColor", "colorKeyword", (_c = config.topBottomRail) == null ? void 0 : _c.color)
        )
      }
    });
  }
  selectedAddons(formData).forEach((addon) => {
    items.push({
      id: addon.variantId,
      quantity: defaultQuantity,
      properties: {
        _parentId: parentId,
        _role: ROLE_ADDON,
        _isUpSell: true,
        ...sizeProperties(config, { width: false }),
        ...baseboardProperties(addon.baseboard)
      }
    });
  });
  return JSON.stringify({
    items,
    sections: cart ? cart.getSectionsToRender().map((section) => section.id) : []
  });
};

// src/extenders/blinds-form.js
var import_pubsub_js = __toESM(require_pubsub(), 1);
if (!customElements.get("blinds-form")) {
  customElements.define(
    "blinds-form",
    class BlindsForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.allInputElements = this.form.querySelectorAll("input, select, textarea, button");
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hideErrors = this.dataset.hideErrors === "true";
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true")
          return;
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.setAttribute("aria-busy", true);
        const config = {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "X-Requested-With": "xmlhttprequest"
          }
        };
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
        }
        config.body = formData;
        if (formData.get("size-variant-id")) {
          config.body = dissectForm(formData);
        }
        fetch(`${routes.cart_add_url}.js`, config).then((response) => response.json()).then((response) => {
          if (response.status) {
            import_pubsub_js.PubSub.publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: response.errors || response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage)
              return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButtonText.classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) {
            import_pubsub_js.PubSub.publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: formData.get("id"),
              cartData: response
            });
          }
          this.error = false;
        }).catch((e) => {
          console.error(e);
        }).finally(() => {
          this.submitButton.setAttribute("aria-busy", false);
          if (!this.error)
            this.submitButton.removeAttribute("aria-disabled");
        });
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors)
          return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper)
          return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
      toggleSubmitButton(disable = true, text2) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text2)
            this.submitButtonText.textContent = text2;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.add_to_cart;
        }
      }
      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
